import { __, sprintf } from '@wordpress/i18n';

const Author = ({headerData}) => {

    // Closes finding v3 S2: previous hardcoded alt="profile" provides no
    // information about which author the avatar belongs to. Use the
    // username if available (the on-screen text), otherwise fall back to
    // an empty string so the image is treated as decorative rather than
    // announced as the literal word "profile".
    const authorName = headerData?.username || '';
    const altText = authorName
        ? sprintf( __( '%s avatar', 'sb-customizer' ), authorName )
        : '';

    return (
        <div className='sb-post-item-author'>
            <img
                src={headerData?.local_avatar_url || headerData?.avatar_url_100}
                alt={altText}
                className='sb-post-item-author-image'
            />

            <p className='sb-post-item-author-name'>
                @{headerData?.username}
            </p>
        </div>
    )
}

export default Author;
